export const components = {
	SensorsList: import('./SensorsList'),
	ThingsAppIcon: import('./AppIcon'),
};
